import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'zh-CN',
    fallbackLng: 'zh-CN',
    debug: false,
    resources: messages,
    defaultNS: 'home',
    ns: ['home'],
    nsSeparator: false,
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;